import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

// Redux
import robotRegistrationReducer from '../../features/RobotRegForm/redux/RobotRegFormSlice';
import supportRequestReducer from '../../features/SupportRequestForm/redux/SupportRequestFormSlice';

// Saga
import { robotRegFormSaga } from '../../features/RobotRegForm/sagas/RobotRegFormSaga';
import { supportRequestSaga } from '../../features/SupportRequestForm/sagas/SupportRequestFormSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    robotRegistration: robotRegistrationReducer,
    supportRequest: supportRequestReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(robotRegFormSaga);
sagaMiddleware.run(supportRequestSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;